/**
 * Seeded PRNG (mulberry32). State is a plain object so it lives inside the
 * serialisable world state; the sim must never use Math.random().
 */
export interface RngState {
	state: number;
}

export function createRng(seed: number): RngState {
	return { state: seed >>> 0 };
}

/** Returns a float in [0, 1) and advances the state. */
export function nextFloat(rng: RngState): number {
	rng.state = (rng.state + 0x6d2b79f5) >>> 0;
	let t = rng.state;
	t = Math.imul(t ^ (t >>> 15), t | 1);
	t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
	return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

/** Returns a float in [min, max). */
export function nextRange(rng: RngState, min: number, max: number): number {
	return min + (max - min) * nextFloat(rng);
}
